import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface GradientBackgroundProps {
  children: React.ReactNode;
  variant?: 'brand' | 'orange' | 'purple' | 'blue' | 'hero';
  sx?: SxProps<Theme>;
}

const GradientBackground: React.FC<GradientBackgroundProps> = ({ 
  children, 
  variant = 'brand',
  sx = {} 
}) => {
  const gradientMap = {
    brand: 'linear-gradient(135deg, #753403 0%, #4F076F 100%)',
    orange: 'linear-gradient(135deg, #753403 0%, #C05A01 100%)',
    purple: 'linear-gradient(135deg, #4F076F 0%, #7E28A4 100%)',
    blue: 'linear-gradient(135deg, #12279E 0%, #314AD7 100%)',
    hero: 'linear-gradient(135deg, #753403 0%, #4F076F 50%, #12279E 100%)',
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: gradientMap[variant],
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default GradientBackground;
